import React from 'react';
import { Webform } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  WebformSelect,
  WebformSignup,
  WebformPostcodeAddressAutocomplete,
} from '..';

import './style.scss';

const WebformWrapper = ({ entity }) => {
  const id = entity.getIn(['field_webform', 0, 'target_id']);
  const status = entity.getIn(['field_webform', 0, 'status']);

  const overriddenComponents = {
    select: WebformSelect,
    address: WebformPostcodeAddressAutocomplete,
    signup: WebformSignup,
  };

  return (
    <div className="Webform__wrapper">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Webform id={id} overriddenComponents={overriddenComponents} status={status} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default WebformWrapper;
